'use client'
import React from 'react'
import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import './About.css'
const abtdepartments = [
  {
    icon: "/images/icons/orange_cardiology.webp",
    title: "Institute of Cardiac Sciences",
    description: "Interventional Cardiology, CTVS, Electrophysiology",
    alt: "Orange Cardiology Icon - HDNA Aarogyam Hospital"
  },
  {
    icon: "/images/icons/orange_nephrology.webp",
    title: "Institute of Renal Science & Transplant",
    description: "Pediatric Nephrology, Renal Transplant, Dialysis, Urology, Nephrology",
    alt: 'Orange Nephrology Icon - HDNA Aarogyam Hospital'
  },
  {
    icon: "/images/icons/orange_orthopedics.webp",
    title: "Department of Orthopaedics & Joint Replacement",
    description: "Comprehensive Joint Replacement Surgery and Orthopedic Care",
    alt: 'Orange Orthopedic Care Icon - HDNA Aarogyam Hospital'
  },
  {
    icon: "/images/icons/orange_neurology.webp",
    title: "Department of Neuro Science",
    description: "Neurology, Brain and Spine Surgery",
    alt: 'Orange Neurology Icon - HDNA Aarogyam Hospital'
  },
  {
    icon: "/images/icons/orange_general-surgery.webp",
    title: "Department of General Laparoscopic",
    description: "State of Art and Specialised 30 bedded intensive care unit for all major specialities",
    alt: 'General Surgery Icon - HDNA Aarogyam Hospital'
  },
  {
    icon: "/images/icons/orange_critical-care.webp",
    title: "Department of Critical Care",
    description: "Providing exceptional care and support to our patients undergoing surgical procedures",
    alt: 'Critical Care Services Icon - HDNA Aarogyam Hospital'
  },
];

const LazyYouTube = () => {
  const [showIframe, setShowIframe] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowIframe(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect(); // cleanup
  }, []);
  return (
    <div ref={ref} className="video-box">
      {showIframe ? (
        <iframe
          width="100%"
          height="300"
          src="https://www.youtube.com/embed/EivqY7kXAQU?autoplay=1&mute=1&loop=1&playlist=EivqY7kXAQU&rel=0&controls=0&showinfo=0"
          title="Aarogyam Hospital video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-forms"
        // sandbox="allow-scripts allow-same-origin allow-presentation"
        />
      ) : (
        <div style={{ height: 300, background: "#000" }}></div>
      )}
    </div>
  );
};

const About = () => {
  return (
    <div>
      <section className='css-about-section css-padding'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='title-section text-centre'>
                <h1 className='css-heading'>
                  <span className='first-title'>About HDNA</span>
                  <span className='second-title'> Aarogyam</span>
                </h1>
                <Image
                  src="/images/DNA.webp"
                  alt="DNA image"
                  width={67}
                  height={21}
                />
              </div>
              <p>
                At <strong>HDNA Aarogyam,</strong> we are dedicated to delivering exceptional healthcare with compassion,
                expertise, and a patient-centric approach. Our commitment to excellence — quality healthcare services available
                24/7 at an affordable price — has made us a trusted healthcare partner in Patna and beyond. Established as a
                centre of excellence for Cardiac & Renal sciences we have emerged as a preferred Healthcare institute of the
                state for heart & kidney related ailments.
              </p>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12 col-lg-12 col-xl-7">
              <div className="row">
                {abtdepartments.map((dept, index) => (
                  <div className="col-md-6 col-lg-6 css-abt-dpt-marginb" key={index}>
                    <div className="abt-department-card d-flex align-items-start">
                      <div className="css-abt-icon-box">
                        <img src={dept.icon} alt="icon" className="abt-dept-icon" loading="lazy" />
                      </div>
                      <div className="text-box ms-2">
                        <p className="abt-dept-title">{dept.title}</p>
                        <p className="abt-dept-description">{dept.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-xl-5">
              <div className="video-wrapper">
                <div className="video-box">
                  <LazyYouTube />
                  {/* <iframe
                    width="100%"
                    height="300"
                    src="https://www.youtube.com/embed/EivqY7kXAQU?autoplay=1&mute=1&loop=1&playlist=EivqY7kXAQU&rel=0&controls=0&showinfo=0"
                    title="Aarogyam Hospital video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    sandbox="allow-scripts allow-same-origin allow-presentation"
                  ></iframe> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About
